import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { FormService } from "../../core/services/form.service";
import { validateEmail } from "../../common/validators/email-validator.directive";
import { validateAllowedCharacters } from "../../common/validators/allowed-characters-validator.directive";
import { validateNumericCharacters } from "../../common/validators/numeric-validator.directive";
import { validateLength } from "../../common/validators/length-validator.directive";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
    selector: 'app-create-redirected-form-invitees',
    templateUrl: './create-redirected-form-invitees.component.html',
    styleUrls: ['./create-redirected-form-invitees.component.css']
})
export class CreateRedirectedFormInviteesComponent implements OnInit {

    createCandidateForm: FormGroup;
    form_token: null;

    constructor(
        private route: ActivatedRoute,
        private fb: FormBuilder,
        private formService: FormService,
        private router: Router
    ) { }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.form_token = params['token'];
        });

        this.createCandidateForm = this.fb.group({
            'email': ['', [Validators.required, validateEmail()]],
            'name': ['', [Validators.required, validateAllowedCharacters('')]],
            'phone_number': ['', [Validators.required, validateNumericCharacters(''), validateLength('10')]],
            'form_token': ['']
        });
    }

    submitForm() {

        this.createCandidateForm.controls.form_token.setValue(this.form_token);

        this.formService.createRedirectedInvitee(this.createCandidateForm.value).subscribe(
            response => {
                if (response['success']) {
                    this.router.navigate(['invites', response['candidate_token']])
                }
            }
        )
    }
}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/form/create-redirected-form-invitees/create-redirected-form-invitees.component.ts